import React, { useState, useRef, useEffect } from 'react';
import Button from '../button/Button';
import { InstrumentationActionButtonContainer, ClickMenu, MenuItem } from './InstrumentationActionButton.styles';

interface InstrumentationActionButtonProps {
  onDecline: () => void;
  onReadyToInstrument: () => void;
  disabled?: boolean;
}

const InstrumentationActionButton: React.FC<InstrumentationActionButtonProps> = ({
  onDecline,
  onReadyToInstrument,
  disabled = false
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleButtonClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleDecline = () => {
    setIsMenuOpen(false);
    onDecline();
  };

  const handleReadyToInstrument = () => {
    setIsMenuOpen(false);
    onReadyToInstrument();
  };

  // Cerrar menú al hacer click fuera del componente
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <InstrumentationActionButtonContainer ref={containerRef}>
      <Button
        id='instrumentation-actions-button'
        size='lg'
        variant='secondary'
        disabled={disabled}
        fullWidth
        onClick={handleButtonClick}
      >
        Acciones
      </Button>
      
      {isMenuOpen && (
        <ClickMenu>
          <MenuItem onClick={handleDecline}>
            Declinar
          </MenuItem>
          <MenuItem onClick={handleReadyToInstrument}>
            Para instrumentar
          </MenuItem>
        </ClickMenu>
      )}
    </InstrumentationActionButtonContainer>
  );
};

export default InstrumentationActionButton;
